import { useEffect, useState } from "react";
import holinesstvbanner from "../otherImg/holinesstvbanner.jpg";
import hbrLogo from "../otherImg/hrmwlitelogo.png";
import Tvscheduleform from "./TvscheduleForm";
import {
  HbrAddIcon,
  HbrCalenderIcon,
  HbrCrossCalendar,
} from "../newComponents/Mycustomsvgicons";
import Calendar from "react-calendar";
import { format } from "date-fns";
import TodaySchedule from "./TodaySchedule";
import Allschedule from "./AllSchedules";
import tvaxiosapi from "../api/tvaxiosapi";
import { ConstVariables } from "./ConstantVariables";

const ProducerDashboard = () => {
  const [scheduleCount, setScheduleCount] = useState(1);
  const lastTimeStorage = sessionStorage.getItem("videoendtime");
  const [dateValue, setDateValue] = useState(new Date());
  const [scheduledVideos, setScheduledVideos] = useState([]);
  const [ispending, setpending] = useState(false);
  const [erroralert, seterroralert] = useState(false);
  const [dbupdated, setDBupdated] = useState(false);

  useEffect(() => {
    const fetchAllVideos = async () => {
      try {
        setpending(true);
        const res = await tvaxiosapi.post(
          "tvshows/allvideos",
          JSON.stringify({
            api_key: ConstVariables.WEB_BOOKS_API_KEY,
            requestType: "all",
          }),
          {
            headers: { "Content-Type": "application/json" },
            withCredentials: false,
          }
        );
        const data = res?.data;
        setScheduledVideos(data);
        setpending(false);
      } catch (err) {
        console.error("unable to fetch all videos", err);
        setpending(false);
        seterroralert(true);
      }
    };
    fetchAllVideos();
  }, [dbupdated]);

  const handleDBupdate = () => {
    setDBupdated((prev) => !prev);
  };

  const handleOndateChanged = (selectedValue) => {
    setDateValue(selectedValue);
    // console.log(format(dateValue,"yyyy-MM-dd"))
  };

  const addMoreSchedules = () => {
    setScheduleCount((prev) => prev + 1);
  };

  const tileClassName = ({ date, view }) => {
    // Add class to current date
    if (
      date.getDate() === new Date().getDate() &&
      date.getMonth() === new Date().getMonth() &&
      date.getFullYear() === new Date().getFullYear()
    ) {
      return "highlighted";
    }
  };

  const handleCancelSchedule = () => {
    if (scheduleCount === 1) {
      alert("cannot delete");
      return;
    }
    setScheduleCount((prev) => prev - 1);
    sessionStorage.removeItem("videoendtime");
  };

  const renderSchedule = () => {
    let schedules = [];
    for (let i = 0; i < scheduleCount; i++) {
      schedules.push(
        <Tvscheduleform
          key={i}
          id={i + 1}
          getLastTime={parseInt(lastTimeStorage && lastTimeStorage)}
          handleCancel={handleCancelSchedule}
          handleUpdateFetch={handleDBupdate}
        />
      );
    }
    return schedules;
  };

  return (
    <div
      className="producerdashb flex-column1"
      style={{
        width: "100%",
        height: "100%",
        overflow: "auto",
        backgroundColor: "#252a41",
      }}
    >
      <div
        className="topproducerdashb"
        style={{
          width: "100%",
          position: "relative",
          backgroundImage: `url(${holinesstvbanner})`,
        }}
      >
        <img
          src={hbrLogo}
          alt=""
          style={{
            width: "100px",
            height: "100px",
            objectFit: "cover",
            position: "absolute",
            top: "20%",
            left: "48%",
            borderRadius: "50px",
          }}
        />
        <h1
          style={{
            color: "white",
            position: "absolute",
            top: "7%",
            left: "42%",
          }}
        >
          Producer Dashboard
        </h1>
      </div>

      <div style={{ display: "flex", flex: "1", width: "100%" }}>
        <div
          className="instantschedule flex-column1"
          style={{
            width: "30%",
            borderRight: "1px solid white",
            gap: "10px",
            height: "100vh",
            overflowY: "auto",
          }}
        >
          <div
            className="flex-row2"
            style={{
              backgroundColor: "green",
              width: "90%",
              padding: "8px",
              borderLeft: "5px solid white",
              borderRight: "5px solid white",
              borderRadius: "10px",
            }}
          >
            <h4 style={{ color: "white" }}>Instant Schedule</h4>
            <HbrCalenderIcon
              width={"1.7em"}
              height={"1.7em"}
              fillColour={"white"}
            />
          </div>
          {renderSchedule()}
          <button
            onClick={addMoreSchedules}
            style={{
              border: "none",
              borderRadius: "10px",
              backgroundColor: "transparent",
              color: "white",
              fontWeight: "bold",
              cursor: "pointer",
            }}
          >
            More Schedule{" "}
            <HbrAddIcon width={"1.7em"} height={"1.7em"} fillColour={"white"} />
          </button>{" "}
          <br />
        </div>

        <div
          className="flex-column1"
          style={{
            width: "30%",
            borderRight: "1px solid white",
            gap: "10px",
            height: "100vh",
            overflowY: "auto",
          }}
        >
          <Calendar
            value={dateValue}
            onChange={handleOndateChanged}
            tileClassName={tileClassName}
          />
          <h4 style={{ color: "white" }}>
            scheduled Videos: {format(dateValue, "yyyy-MM-dd")}
          </h4>{" "}
          <br />
          {ispending && (
            <div
              style={{
                position: "absolute",
                top: "40%",
                left: "45%",
                width: "50px",
                height: "50px",
                border: "5px solid transparent",
                borderTop: "5px solid red",
                borderRadius: "50%",
                animation: "spin2 2s linear infinite",
              }}
            ></div>
          )}
          {erroralert && <p>Failed to fetch All videos !!</p>}
          {scheduledVideos &&
            scheduledVideos
              .filter((scheduleTime) => {
                if (scheduleTime.startTime && dateValue) {
                  try {
                    if (
                      format(
                        new Date(scheduleTime.startTime),
                        "yyyy-MM-dd"
                      ).includes(format(dateValue, "yyyy-MM-dd"))
                    ) {
                      return true;
                    }
                  } catch (error) {
                    console.error(error);
                  }
                }
                return false;
              })
              .map((data) => (
                <TodaySchedule
                  key={data._id}
                  videoThumbnail={data.videoThumbnail}
                  videoTitle={data.videoTitle}
                  startTime={data.startTime}
                  endTime={data.endTime}
                />
              ))}
        </div>

        <div
          className="prevschedule flex-column1"
          style={{
            width: "30%",
            borderRight: "1px solid white",
            gap: "10px",
            paddingLeft: "20px",
            height: "100vh",
            overflowY: "auto",
          }}
        >
          <div
            className="flex-row2"
            style={{
              backgroundColor: "red",
              width: "90%",
              padding: "8px",
              borderLeft: "5px solid white",
              borderRight: "5px solid white",
              borderRadius: "10px",
            }}
          >
            <h4 style={{ color: "white" }}>Previous Schedules</h4>
            <HbrCrossCalendar
              width={"1.7em"}
              height={"1.7em"}
              fillColour={"white"}
            />
          </div>

          {ispending && (
            <div
              style={{
                position: "absolute",
                top: "40%",
                left: "45%",
                width: "50px",
                height: "50px",
                border: "5px solid transparent",
                borderTop: "5px solid red",
                borderRadius: "50%",
                animation: "spin2 2s linear infinite",
              }}
            ></div>
          )}

          {erroralert && <p>Failed to fetch all video schedules</p>}

          {scheduledVideos &&
            scheduledVideos.map((data) => (
              <Allschedule
                key={data._id}
                id={data._id}
                videoThumbnail={data.videoThumbnail}
                videoTitle={data.videoTitle}
                startTime={data.startTime}
                endTime={data.endTime}
                videoUrl={data.videoUrl}
                duration={data.duration}
                handleUpdateDB={handleDBupdate}
              />
            ))}
        </div>
      </div>
    </div>
  );
};
export default ProducerDashboard;
